/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=3efd6690&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3efd6690&scoped=true&lang=css"

import exportComponent from "/data/repos/231_20260317161619/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efd6690"]])

export default __exports__